<template>
  <div class="footer">
    <p>Copyright &copy; 2022 琼ICP备2022015118号 荣鼎盛和（海南）实业有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data () {
    return {

    };
  },
};
</script>
<style lang='scss' scoped>
.footer {
  background: #4f667f;
  height: 30px;
  line-height: 30px;
  z-index: 1002;
  position: fixed;
  bottom: 0;
  width: 100vw;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
}
</style>

